import React from 'react';
import { Glyphicon, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import RuleContainer from './rule-container';
import Rule from './rule';
import NewRule from './new-rule';
import '../../../css/rule/comparison.less';

class Comparison extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isConfirmDelete: false
        };

        this.onChange = this.onChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onCancelDelete = this.onCancelDelete.bind(this);
        this.onNewRule = this.onNewRule.bind(this);

        this.onRuleChange = this.onRuleChange.bind(this);
        this.onRuleCreated = this.onRuleCreated.bind(this);
        this.onRuleDeleted = this.onRuleDeleted.bind(this);
        this.onCancelNewRule = this.onCancelNewRule.bind(this);

        this.onComparisonCreated = this.onComparisonCreated.bind(this);
        this.onComparisonDeleted = this.onComparisonDeleted.bind(this);
        this.onChangeComparisonOrder = this.onChangeComparisonOrder.bind(this);
    }

    onChange(type) {
        manywho.utils.setObjectDataProperty(this.props.objectData.properties, 'ComparisonType', type);
        this.props.onChange(this.props.objectData);
    }

    onDelete() {
        if (!this.state.isConfirmDelete)
            this.setState({ isConfirmDelete: true });
        else if (this.props.onDelete)
            this.props.onDelete(this.props.objectData);
    }

    onCancelDelete() {
        this.setState({ isConfirmDelete: false });
    }

    onNewRule() {
        this.setState({ isNewRuleVisible: true });
    }

    onCancelNewRule() {
        this.setState({ isNewRuleVisible: false });
    }

    onRuleChange() {
        this.props.onChange(this.props.objectData);
    }

    onRuleCreated(left, criteria, right) {
        const rules = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'Rules');

        if (rules.objectData === null)
            rules.objectData = [];

        rules.objectData.push({
            externalId: null,
            typeElementId: '194f9394-29b8-4548-9a79-f193e8ba15af',
            properties: [
                {
                    developerName: 'leftValueElementToReferenceId',
                    typeElementPropertyId: 'ef396c6b-9413-4eca-a6bb-58eaafbaa028',
                    objectData: [left]
                },
                {
                    developerName: 'rightValueElementToReferenceId',
                    typeElementPropertyId: '79193611-15be-4b53-9c38-783e608d812a',
                    objectData: [right]
                },
                {
                    developerName: 'criteriaType',
                    typeElementPropertyId: 'f193a8a7-4b3a-45aa-838b-8b60bd925bec',
                    contentValue: criteria
                }
            ]
        });

        this.setState({ isNewRuleVisible: false });
        this.props.onChange(this.props.objectData);
    }

    onRuleDeleted(rule) {
        const rules = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'Rules');
        const index = rules.objectData.indexOf(rule);

        if (index !== -1)
            rules.objectData.splice(index, 1);

        this.props.onChange(this.props.objectData);
    }

    onComparisonCreated(type) {
        const comparisons = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'Comparisons');

        if (comparisons.objectData === null)
            comparisons.objectData = [];

        comparisons.objectData.push({
            externalId: null,
            typeElementId: 'c6dd5dfd-b4d3-4bad-bd26-d979fdf433d5',
            properties: [
                {
                    developerName: 'comparisonType',
                    contentValue: type,
                    typeElementPropertyId: '1e7ecff3-db94-44be-affe-79c255ee4d34'
                },
                {
                    developerName: 'comparisons',
                    objectData: [],
                    typeElementPropertyId: 'b0241fee-cd10-4f2e-9bc6-e1e2a3baeda1'
                },
                {
                    developerName: 'rules',
                    objectData: [],
                    typeElementPropertyId: '2df9d0c7-fa48-45cf-b477-be4c23b2988e'
                },
                {
                    developerName: 'order',
                    contentValue: comparisons.objectData.length,
                    typeElementPropertyId: '5a53a0ba-0df2-4da2-8aa2-5f153b75c969'
                }
            ]
        });

        this.setState({ isNewRuleVisible: false });
        this.props.onChange(this.props.objectData);
    }

    onComparisonDeleted(comparison) {
        const comparisons = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'Comparisons');
        const index = comparisons.objectData.indexOf(comparison);

        if (index !== -1)
            comparisons.objectData.splice(index, 1);

        this.props.onChange(this.props.objectData);
    }

    onChangeComparisonOrder(comparison, increment) {
        let comparisons = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'Comparisons').objectData;
        const order = parseInt(manywho.utils.getObjectDataProperty(comparison.properties, 'Order').contentValue);

        comparisons.splice(order + increment, 0, comparisons.splice(order, 1)[0]);
        comparisons = comparisons.map((item, index) => {
            manywho.utils.setObjectDataProperty(item.properties, 'Order', index);
            return item;
        });

        this.props.onChange(this.props.objectData);
    }

    render() {
        const comparisonType = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'ComparisonType').contentValue;
        const comparisonTypeLabel = manywho.utils.isEqual(comparisonType, 'OR', true) ? 'Any' : 'All';

        const rules = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'Rules').objectData;
        const comparisons = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'Comparisons').objectData;

        let iconClassName = 'remove-sign';

        if (this.state.isConfirmDelete)
            iconClassName += ' confirm-delete';

        return <div className="comparison">
            <div className="comparison-group-open">
                <DropdownButton id={comparisonTypeLabel} title={comparisonTypeLabel} ref="target" onSelect={this.onChange}>
                    <MenuItem eventKey="AND">All</MenuItem>
                    <MenuItem eventKey="OR">Any</MenuItem>
                </DropdownButton>
                {!this.props.isRoot ? <Button className="btn-nobackground" onClick={this.onDelete} onBlur={this.onCancelDelete}>
                    <Glyphicon glyph={iconClassName} />
                    <div></div>
                </Button> : null}
                {this.props.onIncrementOrder ? <Glyphicon glyph="download" onClick={this.props.onIncrementOrder} /> : null}
                {this.props.onDecrementOrder ? <Glyphicon glyph="upload" onClick={this.props.onDecrementOrder} /> : null}
            </div>
            {
                (rules || []).map((rule, index) => <RuleContainer component={Rule} objectData={rule} objectDataRequest={this.props.objectDataRequest} onChange={this.onRuleChange} onDelete={this.onRuleDeleted} flowId={this.props.flowId} key={index} />)
            }
            {
                this.state.isNewRuleVisible ?
                    <RuleContainer component={NewRule} objectDataRequest={this.props.objectDataRequest} onRuleCreated={this.onRuleCreated} onCancel={this.onCancelNewRule} flowId={this.props.flowId} /> :
                    <div className="comparison-new-item">
                        <button className="btn btn-success" onClick={this.onNewRule}>New Rule</button>
                        <DropdownButton bsStyle="primary" id="New Comparison" title="New Comparison" onSelect={this.onComparisonCreated}>
                            <MenuItem eventKey="AND">All</MenuItem>
                            <MenuItem eventKey="OR">Any</MenuItem>
                        </DropdownButton>
                    </div>
            }
            {
                (comparisons || [])
                    .sort((a, b) => {
                        return parseInt(manywho.utils.getObjectDataProperty(a.properties, 'Order').contentValue) -
                            parseInt(manywho.utils.getObjectDataProperty(b.properties, 'Order').contentValue);
                    })
                    .map((comparison, index) => {
                        return <Comparison objectData={comparison}
                                            objectDataRequest={this.props.objectDataRequest}
                                            onChange={this.props.onChange.bind(null, this.props.objectData)}
                                            onDelete={this.onComparisonDeleted}
                                            onIncrementOrder={index < comparisons.length - 1 ? this.onChangeComparisonOrder.bind(null, comparison, 1) : null}
                                            onDecrementOrder={index > 0 ? this.onChangeComparisonOrder.bind(null, comparison, -1) : null}
                                            flowId={this.props.flowId}
                                            key={index} />;
                    })
            }
            {this.state.isConfirmDelete ? <div className="rule-delete-overlay" onClick={this.onCancelDelete}/> : null}
        </div>;
    }
}

export default Comparison;
